import React from 'react';
import AgentActivities from 'containers/Organizations/SingleOrganization/Agents/Activities';

export default {
  name: 'agents',
  path: /.*\/organizations\/\d+\/agents\/\d+\/activities$/,
  component: <AgentActivities />,
};
